import React, { useState, KeyboardEvent } from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

interface OpportunitySearchProps {
  onSearch: (email: string, mode: "prospect" | "salesperson") => void;
  loading: boolean;
}

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function OpportunitySearch({ onSearch, loading }: OpportunitySearchProps) {
  const [mode, setMode] = useState<"prospect" | "salesperson">("prospect");
  const [email, setEmail] = useState("");

  const isEmailValid = EMAIL_REGEX.test(email);
  const isDisabled = !email || !isEmailValid || loading;

  function handleSearch() {
    if (!isDisabled) {
      onSearch(email, mode);
    }
  }

  function handleKeyDown(e: KeyboardEvent<HTMLInputElement>) {
    if (e.key === "Enter") {
      handleSearch();
    }
  }

  return (
    <div className="flex items-center gap-2">
      <div className="w-40 shrink-0">
        <Select
          onValueChange={(value) =>
            setMode(value as "prospect" | "salesperson")
          }
          value={mode}
        >
          <SelectTrigger>
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="prospect">Prospect</SelectItem>
            <SelectItem value="salesperson">Salesperson</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <Input
        className="flex-1"
        onChange={(e) => setEmail(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder="Enter email address..."
        type="email"
        value={email}
      />
      <Button disabled={isDisabled} onClick={handleSearch}>
        {loading ? "Searching..." : "Search"}
      </Button>
    </div>
  );
}

export { OpportunitySearch };
export default OpportunitySearch;
